import React, { useEffect, useState } from 'react';
import { UserRound } from 'lucide-react';
import { siteRequestHeaders } from '../../lib/siteRequestHeaders';
import './settings.css';

export const ProfileAvatar = ({ avatarId, name = 'Player', testid, size = 36 }) => {
  const [failed, setFailed] = useState(false);
  const [source, setSource] = useState(null);
  useEffect(() => {
    setFailed(false); setSource(null);
    if (!avatarId) return;
    const controller = new AbortController(); let objectUrl;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/avatars/${avatarId}`, { headers: siteRequestHeaders(), signal: controller.signal })
      .then((response) => { if (!response.ok) throw new Error(); return response.blob(); })
      .then((blob) => { if (!controller.signal.aborted) { objectUrl = URL.createObjectURL(blob); setSource(objectUrl); } })
      .catch(() => { if (!controller.signal.aborted) setFailed(true); });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [avatarId]);
  return <span className="profile-avatar-image" style={{ '--avatar-size': `${size}px` }} data-testid={testid}>
    {source && !failed ? <img src={source} alt={`${name}'s profile`} data-testid={`${testid}-image`} onError={() => setFailed(true)} /> : <UserRound size={Math.round(size * .55)} aria-hidden="true" />}
  </span>;
};